import OneDocAiQuestion from './OneDocAiQuestion';
import OneDocAiAnswer from './OneDocAiAnswer';
import React from 'react';

const InteractiveChatWrapper = React.memo(({ children, className, ...rest }) => (
  <div className={`interactive-prompt${className ? ' ' + className : ''}`}>
    {children && React.cloneElement(children, { ...rest })}
  </div>
));

const OneDocAiInteractiveChat = React.memo(({ chat, isTopInStack, popQuestionIfAllowed }) => {
  return (
    <>
      {chat.from !== 'ai' && (
        <InteractiveChatWrapper
          className="interactive-question"
          chat={chat}
          isTopInStack={isTopInStack}
          popQuestionIfAllowed={popQuestionIfAllowed}
        >
          <OneDocAiQuestion />
        </InteractiveChatWrapper>
      )}
      {chat.from === 'ai' && (
        <InteractiveChatWrapper className={`interactive-answer ${chat.status === 'error' ? 'error' : ''}`} chat={chat}>
          <OneDocAiAnswer />
        </InteractiveChatWrapper>
      )}
    </>
  );
});

export default OneDocAiInteractiveChat;
